import axios from 'axios';

import endpointNames from "../configs/serverUrls";

//url variable
const baseUrl = endpointNames.package;
// get User Token
// let user = JSON.parse(localStorage.getItem('user'));
//gets token from localStorage
let token = JSON.parse(localStorage.getItem('token'));

//add policy holder
const addProductPackage = async (request) => {
    let response;
    console.log(request)

    let data = {
        "product_id": request.product_id,
        "sum_assured": request.sum_assured,
        "premium": request.premium,
        "monthly_investments_premium": request.monthly_investments_premium,
        "clawback_period": request.clawback_period,
        "term": request.term,
        "cows_after_maturity": request.cows_after_maturity,
        "calf_after_maturity": request.calf_after_maturity,
    }

    console.log("data: ", data);

    await axios.post(baseUrl + 'product/package', data, {

        headers: {Authorization: `Bearer ${token}`},
    })
        .then(res => {
            console.log("server response: ", res);
            response = res;
        })
        .catch(err => {
            console.log("server error: ", err);
            response = err;
        });
    return response;
}

//update policy holder
const updateProductPackage = async (d) => {
    let response;
    console.log(token);

    let data = {
        "id": d.policyHolderId,
        "title": d.title,
        "first_name": d.first_name,
        "last_name": d.last_name,
        "date_of_birth": d.date_of_birth,
        "id_number": d.id_number,
        "gender": d.gender,
        "work_telephone": d.work_telephone,
        "mobile": d.mobile,
        "email": d.email,
        "ec_number": d.ec_number,
        "aggregator_id": 1,
        "occupation": d.occupation,
        "physical_address_street": d.physical_address_street,
        "physical_address_suburb": d.physical_address_suburb,
        "physical_address_city": d.physical_address_city,
        "postal_address_street": d.postal_address_street,
        "postal_address_suburb": d.postal_address_suburb,
        "postal_address_city": d.postal_address_city,
        "smoker_status": d.smoker_status,
        "salary": parseInt(d.salary),
        "clientType": "SSB"
    }

    //url should be baseUrl + '/update/'+ d.policyHolderId
    await axios.put(baseUrl + '/update/' + d.policyHolderId, data, {
        headers: {Authorization: `Bearer ${token}`},
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;

}

//delete policy holder
const getAllPackages = async (id) => {
    let response;

    await axios.delete(baseUrl + '/' + id)
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

//update policy holder

//get policy holder details
const getProductPackages = async (id) => {
    let response;
    const config = {
        headers: {Authorization: `Bearer ${token}`}
    };
    await axios.get(baseUrl + '/' + id, config)
        .then(res => {
            // console.log(res);
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}


export default {
    getProductPackages,
    updateProductPackage,
    addProductPackage,
    getAllPackages,
}
